function preventDoubleTap(e: MouseEvent) {
    e.preventDefault()
}

// disable double tap zoom in Safari on iOS
export default function () {
    useEventListener(document, 'dblclick', preventDoubleTap)
}
